export interface PairSpec {
  symbol: string;
  name: string;
  pipSize: number;
  decimals: number;
  lotSize: number;
  type: 'usd_quote' | 'usd_base' | 'cross';
}

export const FOREX_PAIRS: Record<string, PairSpec> = {
  'EUR/USD': {
    symbol: 'EUR/USD',
    name: 'Euro / US Dollar',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'usd_quote',
  },
  'GBP/USD': {
    symbol: 'GBP/USD',
    name: 'British Pound / US Dollar',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'usd_quote',
  },
  'USD/JPY': {
    symbol: 'USD/JPY',
    name: 'US Dollar / Japanese Yen',
    pipSize: 0.01,
    decimals: 3,
    lotSize: 100000,
    type: 'usd_base',
  },
  'USD/CHF': {
    symbol: 'USD/CHF',
    name: 'US Dollar / Swiss Franc',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'usd_base',
  },
  'AUD/USD': {
    symbol: 'AUD/USD',
    name: 'Australian Dollar / US Dollar',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'usd_quote',
  },
  'NZD/USD': {
    symbol: 'NZD/USD',
    name: 'New Zealand Dollar / US Dollar',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'usd_quote',
  },
  'USD/CAD': {
    symbol: 'USD/CAD',
    name: 'US Dollar / Canadian Dollar',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'usd_base',
  },
  'EUR/JPY': {
    symbol: 'EUR/JPY',
    name: 'Euro / Japanese Yen',
    pipSize: 0.01,
    decimals: 3,
    lotSize: 100000,
    type: 'cross',
  },
  'GBP/JPY': {
    symbol: 'GBP/JPY',
    name: 'British Pound / Japanese Yen',
    pipSize: 0.01,
    decimals: 3,
    lotSize: 100000,
    type: 'cross',
  },
  'EUR/GBP': {
    symbol: 'EUR/GBP',
    name: 'Euro / British Pound',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'cross',
  },
  'AUD/JPY': {
    symbol: 'AUD/JPY',
    name: 'Australian Dollar / Japanese Yen',
    pipSize: 0.01,
    decimals: 3,
    lotSize: 100000,
    type: 'cross',
  },
  'EUR/AUD': {
    symbol: 'EUR/AUD',
    name: 'Euro / Australian Dollar',
    pipSize: 0.0001,
    decimals: 5,
    lotSize: 100000,
    type: 'cross',
  },
};

export const DEFAULT_PAIR = 'EUR/USD';
